/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-named-as-default */
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { withRouter } from 'react-router';

// Contexts
import { GroupConsumer } from '../../../../contexts/GroupContext';
import { groupActions } from '../../../Includes/GroupActionTypes';
import CommonCardShell from '../../../Layout/CommonCardShell/CommonCardShell';
import RightRailContent from '../../../Layout/ThreeColumnGridLayout/RightRailContent/RightRailContent';
import ThreeColumnLayout from '../../../Layout/ThreeColumnLayout/ThreeColumnLayout';
import LeftRailContent from '../../../LeftRailLayout/LeftRailContent/LeftRailContent';
// Layout Components
import LeftRailLayout from '../../../LeftRailLayout/LeftRailLayout';
import PostBoxContainer from '../../../UnifiedPostBox/PostBoxContainer/PostBoxContainer';
import UserIconListDisplay from '../../../Users/UserIconListDisplay/UserIconListDisplay';
import AboutCard from '../../AboutCard/AboutCard';
import GroupInviteCTA from '../../CtaCards/GroupInviteCTA/GroupInviteCTA';
import GroupChatPreview from '../../GroupChatPreview/GroupChatPreview';
// Content Components
import AdminMenuSection from '../../Modals/AdminMenuSection/AdminMenuSection';
import RulesCard from '../../RulesCard/RulesCard';

// Styles
import './HomeLayout.scss';
import GroupStartPostButton from '../../Elements/GroupStartPostButton/GroupStartPostButton';
import useStickyContent from '../../../../hooks/useStickyContent';

// @TODO later update logic for hiding post button, all except homepage.
export function Home(props) {
    const compareRef = useRef(null);
    const leftRef = useRef(null);
    const rightRef = useRef(null);

    const [leftStyles] = useStickyContent(
        leftRef,
        false,
        40,
        compareRef,
        rightRef
    );
    const [rightStyles] = useStickyContent(
        rightRef,
        false,
        30,
        compareRef,
        leftRef
    );

    const { innerRef, children, featureFlags } = props;
    const isGroupChatPage =
        props.location.pathname.split('/').indexOf('group-chat') !== -1;
    return (
        <main
            className="component-Groups-Layout-HomeLayout bias-for-reaction-styling"
            ref={innerRef}
        >
            <GroupConsumer>
                {(groupContext) => {
                    if (
                        groupContext.hasPermission(groupActions.VIEW_CONTENTS)
                    ) {
                        const { group, isMember } = groupContext;
                        const { modalTrigger } = props;
                        const messageType = 'group-chat-room';
                        const channelKey = `${messageType}-${group.hash}`;

                        const groupInviteCtaProps = {
                            modalTrigger,
                            group,
                            featureFlags,
                        };

                        const locationPath = props.location?.pathname;
                        const isHomePage =
                            locationPath ===
                                `/groups/${group.hash}/${group.slug}` ||
                            locationPath === `/groups/${group.hash}`;

                        return (
                            <ThreeColumnLayout>
                                <ThreeColumnLayout.LeftRail
                                    stickyContent={{
                                        ref: leftRef,
                                        styles: leftStyles,
                                    }}
                                >
                                    <LeftRailContent displayLeftRailFooter />
                                </ThreeColumnLayout.LeftRail>

                                <ThreeColumnLayout.MainContent
                                    stickyContent={{ ref: compareRef }}
                                >
                                    {featureFlags.unifiedPostBox &&
                                        isMember() && (
                                            <PostBoxContainer
                                                pageGroup={group}
                                            />
                                        )}
                                    {children}
                                </ThreeColumnLayout.MainContent>

                                <ThreeColumnLayout.RightRail
                                    stickyContent={{
                                        ref: rightRef,
                                        styles: rightStyles,
                                    }}
                                >
                                    <RightRailContent>
                                        {groupContext.hasPermission(
                                            groupActions.CAN_INVITE
                                        ) && (
                                            <CommonCardShell>
                                                <GroupInviteCTA
                                                    {...groupInviteCtaProps}
                                                />
                                            </CommonCardShell>
                                        )}

                                        {groupContext.hasPermission(
                                            groupActions.POST_CONTENTS
                                        ) &&
                                            isHomePage && (
                                                <CommonCardShell>
                                                    <GroupStartPostButton
                                                        group={group}
                                                        closeModalHandler={
                                                            modalTrigger
                                                        }
                                                    />
                                                </CommonCardShell>
                                            )}

                                        {groupContext.hasPermission(
                                            groupActions.SHOW_ADMIN_MENU
                                        ) && (
                                            <CommonCardShell>
                                                <AdminMenuSection
                                                    groupHash={group.hash}
                                                />
                                            </CommonCardShell>
                                        )}

                                        {!isGroupChatPage &&
                                            groupContext.hasPermission(
                                                groupActions.GROUP_CHAT
                                            ) && (
                                                <CommonCardShell>
                                                    <GroupChatPreview
                                                        messageType={
                                                            messageType
                                                        }
                                                        channelKey={channelKey}
                                                    />
                                                </CommonCardShell>
                                            )}

                                        <CommonCardShell>
                                            <AboutCard
                                                displayText={group.aboutGroup}
                                                locationList={group.locations}
                                            />
                                        </CommonCardShell>

                                        <UserIconListDisplay
                                            getUserList={
                                                groupContext.getMemberList
                                            }
                                            header="members"
                                            hint="A = Admin; M = Moderator"
                                            showVipBadge={false}
                                        />

                                        {group && group.rules && (
                                            <CommonCardShell>
                                                <RulesCard
                                                    displayText={group.rules}
                                                />
                                            </CommonCardShell>
                                        )}
                                    </RightRailContent>
                                </ThreeColumnLayout.RightRail>
                            </ThreeColumnLayout>
                        );
                    }

                    return (
                        <LeftRailLayout>
                            <LeftRailLayout.LeftRail
                                stickyContent={{
                                    ref: leftRef,
                                    styles: leftStyles,
                                }}
                            >
                                <LeftRailContent displayLeftRailFooter />
                            </LeftRailLayout.LeftRail>

                            <LeftRailLayout.MainContent>
                                {children}
                            </LeftRailLayout.MainContent>
                        </LeftRailLayout>
                    );
                }}
            </GroupConsumer>
        </main>
    );
}

Home.propTypes = {
    modalTrigger: PropTypes.func.isRequired,
    featureFlags: PropTypes.object,
};

Home.defaultProps = {
    featureFlags: {},
};

export default withRouter(Home);
